import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addRenewalNote } from '../api/AddRenewalNote';

interface AddRenewalNoteParams {
  renewalUuid: string;
  content: string;
}

export const useAddRenewalNotes = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ renewalUuid, content }: AddRenewalNoteParams) =>
      addRenewalNote(renewalUuid, content),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['renewals'] });
      queryClient.invalidateQueries({
        queryKey: ['renewal', variables.renewalUuid],
      });
    },
  });

  return {
    addNote: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
